import { render, staticRenderFns } from "./FeeEditStudentComponent.vue?vue&type=template&id=7134793b&"
import script from "./FeeEditStudentComponent.vue?vue&type=script&lang=js&"
export * from "./FeeEditStudentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports